// extracted by mini-css-extract-plugin
module.exports = {"container":"GlobalAdminItem_container__3MRHd","item":"GlobalAdminItem_item__3U5WT","button":"GlobalAdminItem_button__3JLOW"};